import React from 'react';
import { FDBox } from '@facet-wealth/design';

const ServiceDetails = () => {
  return (
    <FDBox height={'100%'} width={'100%'}>
      {'ServiceDetails - Coming Soon'}
    </FDBox>
  );
};

ServiceDetails.defaultProps = {};

ServiceDetails.propTypes = {};

export { ServiceDetails };
